/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_FollowersInputs */

const en_follow_followers = /** @type {(inputs: Follow_FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Followers`)
};

const es_follow_followers = /** @type {(inputs: Follow_FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguidores`)
};

const fr_follow_followers = /** @type {(inputs: Follow_FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnés`)
};

const de_follow_followers = /** @type {(inputs: Follow_FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follower`)
};

const id_follow_followers = /** @type {(inputs: Follow_FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengikut`)
};

/** @type {(inputs: Follow_FollowersInputs) => LocalizedString} */
const ja_follow_followers = en_follow_followers;

/** @type {(inputs: Follow_FollowersInputs) => LocalizedString} */
const zh_follow_followers = en_follow_followers;

/** @type {(inputs: Follow_FollowersInputs) => LocalizedString} */
const ar_follow_followers = en_follow_followers;

/** @type {(inputs: Follow_FollowersInputs) => LocalizedString} */
const it_follow_followers = en_follow_followers;

/** @type {(inputs: Follow_FollowersInputs) => LocalizedString} */
const ru_follow_followers = en_follow_followers;

/** @type {(inputs: Follow_FollowersInputs) => LocalizedString} */
const pt_follow_followers = en_follow_followers;

/** @type {(inputs: Follow_FollowersInputs) => LocalizedString} */
const ko_follow_followers = en_follow_followers;

/**
* | output |
* | --- |
* | "Followers" |
*
* @param {Follow_FollowersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const follow_followers = /** @type {((inputs?: Follow_FollowersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_FollowersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follow_followers(inputs)
	if (locale === "es") return es_follow_followers(inputs)
	if (locale === "fr") return fr_follow_followers(inputs)
	if (locale === "de") return de_follow_followers(inputs)
	if (locale === "ja") return ja_follow_followers(inputs)
	if (locale === "zh") return zh_follow_followers(inputs)
	if (locale === "ar") return ar_follow_followers(inputs)
	if (locale === "id") return id_follow_followers(inputs)
	if (locale === "it") return it_follow_followers(inputs)
	if (locale === "ru") return ru_follow_followers(inputs)
	if (locale === "pt") return pt_follow_followers(inputs)
	return ko_follow_followers(inputs)
});